import { KoIfNot } from "@/index"

/**
 * @deprecated Use `KoIfNot` instead. This component will be removed in a future version.
 */
export const KoIfNotComment = KoIfNot
